
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 5.444v7.112c0 1.178.527 2.309 1.464 3.142C6.402 16.532 7.674 17 9 17s2.598-.468 3.536-1.302c.937-.833 1.464-1.964 1.464-3.142V4.11c0-.825-.369-1.616-1.025-2.2C12.319 1.328 11.428 1 10.5 1c-.928 0-1.819.328-2.475.911C7.37 2.495 7 3.286 7 4.111v7.556c0 .471.21.923.586 1.257.375.333.884.52 1.414.52.53 0 1.04-.187 1.414-.52.375-.334.586-.786.586-1.257V5.444","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    